export default function Btn({ children, onClick, variant = "default", small = false, disabled = false, title, className = "" }) {
  return (
    <button 
      onClick={disabled ? undefined : onClick} 
      title={title}
      disabled={disabled}
      className={`btn btn--${variant} ${small ? "btn--small" : ""} ${className}`.trim()}
    >
      {children}
    </button>
  );
}